import { ReactNode } from 'react'

import { CookieAcceptation, useCookieAcceptation } from '@/widgets/CookieAcceptation'
import { useVpnNotice, VpnNotice } from '@/widgets/VpnNotice'

type SiteNoticeItem = {
	id: string
	isVisible: boolean
	render: () => ReactNode
}

export const useSiteNotice = (): SiteNoticeItem[] => {
	const { isVisible: isCookieVisible, handleAccept } = useCookieAcceptation()
	const { isVisible: isVpnVisible, handleDismiss } = useVpnNotice()

	return [
		{
			id: 'cookie',
			isVisible: isCookieVisible,
			render: () => <CookieAcceptation onAccept={handleAccept} />
		},
		{
			id: 'vpn',
			isVisible: isVpnVisible,
			render: () => <VpnNotice onDismiss={handleDismiss} />
		}
	]
}
